import InvoicesContainer from "./InvoicesContainer";

export default InvoicesContainer;
